/* eslint-disable react-hooks/exhaustive-deps */
import {
  alpha,
  Badge,
  Box,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Popover,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import { styled } from '@mui/material/styles';
import { translate } from 'src/i18n/tHelper';
import { useLazyMesajOkunduQuery, useMesajModulOkumaBilgiQuery } from 'src/services/Mesaj/MesajApi';
import { helper } from 'src/utils/helper';
import { useAppDispatch, useAppSelector } from 'src/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { MesajSlice } from 'src/store/Slices/Mesaj/MesajSlice';
import VwGnlMesajDTO from 'src/models/Mesaj/VwGnlMesajDTO';
import NotificationDetails from './NotificationDetails';
import api from 'src/services/core/api';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import MesajOkumaBilgisiResponse from 'src/models/Mesaj/MesajOkumaBilgisiResponse';
import TablePagination from 'src/components/TablePagination';
import { Skeleton } from 'src/components';
import { ApiResponse, ApiService } from 'src/services/core';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';
// import { useLocation } from 'react-router';

/**
 * Bildirim rozeti için özelleştirilmiş stillendirmeyi sağlayan bileşen.
 * Bu bileşen, MuiBadge bileşenini temel alır ve bildirim rozeti için özel bir görünüm sağlar.
 */
const NotificationsBadge = styled(Badge)(({ theme }) => `
    .MuiBadge-badge {
        background-color: ${alpha(theme.palette.error.main, 0.1)};
        color: ${theme.palette.error.main};
        min-width: 16px; 
        height: 16px;
        padding: 0;
        &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            animation: ripple 1.2s infinite ease-in-out;
            border: 1px solid currentColor;
            content: '""';
        }
    }
    @keyframes ripple {
        0% {
            transform: scale(.8);
            opacity: 1;
        }
        100% {
            transform: scale(2.4);
            opacity: 0;
        }
    }
`);

const ModernHeaderButton = styled(IconButton)(
  ({ theme }) => `
    width: 28px;
    height: 28px;
    border-radius: 4px;
    background: transparent;
    border: 1px solid ${alpha(theme.palette.divider, 0.1)};
    transition: all 0.2s ease;
    margin: 0;
    
    &:hover {
      background: ${alpha(theme.palette.primary.main, 0.08)};
      border-color: ${alpha(theme.palette.primary.main, 0.2)};
      transform: translateY(-1px);
      box-shadow: 0 1px 4px ${alpha(theme.palette.primary.main, 0.15)};
    }
    
    &:active {
      transform: translateY(0);
    }
    
    .MuiSvgIcon-root {
      font-size: 14px;
      transition: all 0.2s ease;
      color: ${theme.palette.text.primary};
    }
    
    &:hover .MuiSvgIcon-root {
      color: ${theme.palette.primary.main};
    }
`
);

const StyledBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: 500,
  width: 440,
  bgcolor: 'background.paper',
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
  '&:hover': {
    scrollbarColor: 'rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0)',
  },
});

const translatePath = "parts|mesaj";
/**
 * Header'da modül bildirimleri için kullanılan component
 * @returns 
*/
const HeaderNotifications = (): JSX.Element => {
  const state = useAppSelector(s => s.mesaj);
  const userInfo = useAppSelector(s => s.userLogin.userInfo);
  const organizasyon = useAppSelector(s => s.userOrganizasyon.organizasyon);
  const dispatch = useAppDispatch();
  const confirm = useConfirmation();

  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);
  // const query = useMesajModulListesiQuery({ organizasyonId: organizasyon.fkOrganizasyon, page: page, pageSize: pageSize }, { skip: (organizasyon.fkOrganizasyon > 0) ? false : true });
  const querySayac = useMesajModulOkumaBilgiQuery({ kullaniciId: userInfo.id, organizasyonId: organizasyon.fkOrganizasyon, paginationModel: { page: page, pageSize: pageSize } }, { skip: (userInfo?.id > 0 && organizasyon?.fkOrganizasyon > 0) ? false : true });
  const [oku, okuState] = useLazyMesajOkunduQuery();

  const [query, setQueryData] = useState<ApiResponse<Array<VwGnlMesajDTO>>>({ data: [], errorMessage: "", responseCode: 0, totalRecords: 0, version: "" });
  // const location = useLocation();
  // const menuAuth = useAppSelector(s => s.menuAuth.data);
  // const modulKayitlari = !!menuAuth?.find((f) => f.link === location?.pathname && f.seviye >= 2 && f.tipi === 17);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  /**
   * Bildirime tıklandığında detay penceresinin açılması için kullanılan fonksiyon
   * @param event 
  */
  const popoverOpenHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    dispatch(MesajSlice.actions.setModulListeFetching(true));
    setAnchorEl(event.currentTarget);
  };
  /**
   * Detay penceresini kapatmak için kullanılan fonksiyon
  */
  const popoverCloseHandler = () => {
    setAnchorEl(null);
  };
  /**
   * Server side mesajların gelmesi için axios kullanıldı usecallback ile fonksiyon sarmalanıp state set edildi.
  */
  const loadData = useCallback(async () => {
    if (state.modulListeFetching) {
      const res = await new ApiService("Mesaj").get<Array<VwGnlMesajDTO>>("MesajModulListesi", {
        organizasyonId: organizasyon.fkOrganizasyon,
        page: page,
        pageSize: pageSize
      });
      if (res.responseCode !== 200) {
        confirm({
          variant: 'info',
          title: '',
          description: res.errorMessage
        });
        dispatch(MesajSlice.actions.setModulListeFetching(false));
        return;
      }
      setQueryData(res);
      dispatch(MesajSlice.actions.setModulListeFetching(false));
    }
  }, [state.modulListeFetching, open, page, pageSize]);
  useEffect(() => {
    loadData();
  }, [loadData]);

  const [querySayacData, setQuerySayacData] = useState<Array<MesajOkumaBilgisiResponse>>(new Array<MesajOkumaBilgisiResponse>());
  /**
   * Sayaç querysi döndükten sonra stateyi set eden usecallback fonksiyon
  */
  const loadQuerySayac = useCallback(() => {
    if (!querySayac.isFetching && querySayac.data?.length === 0) {
      setQuerySayacData([]);
      return;
    }
    if (!querySayac.isFetching && querySayac.data?.length > 0)
      setQuerySayacData(querySayac.data);
  }, [querySayac.isFetching, open, page, pageSize]);
  useEffect(() => {
    loadQuerySayac();
  }, [loadQuerySayac]);

  /**
   * Modül bazlı bildirim oluşturma penceresini açan fonksiyon
   * @param event 
  */
  const addHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    dispatch(MesajSlice.actions.setMuracaatId(0));
    dispatch(MesajSlice.actions.setModulActiveRow({ ...new VwGnlMesajDTO(), ekleyenKullanici: userInfo.id }));
    dispatch(MesajSlice.actions.setModulOpen(true));
  };
  /**
   * Liste içerisinde detayını pencerede detaylı göstermeye yarayan fonksiyon
   * Eğer mesaj okunmamışsa mesajıda apiye gönderip kullanıcı bazlı okuma yapar
   * @param event 
   * @param row 
   * @returns 
  */
  const detailHandler = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>, row: VwGnlMesajDTO) => {
    const okunacakMi = querySayacData?.find((f) => f.mesajId === row.id);
    if (okunacakMi?.okumaBilgisi > 0) {
      if (!okuState.isFetching) {
        await oku({ mesajId: row?.id }).unwrap().then(() => {
          dispatch(api.util.invalidateTags(["MesajOkumaBilgi", "MesajModulOkumaBilgi"]));
          dispatch(MesajSlice.actions.setModulActiveRow(row));
          dispatch(MesajSlice.actions.setModulOpen(true));
        }).catch(e => e);
      }
      return;
    }
    dispatch(MesajSlice.actions.setModulActiveRow(row));
    dispatch(MesajSlice.actions.setModulOpen(true));
  };
  /**
   * Server side çalıştırmak için table pagination componenti kullanıldı sayfa değiştirme fonksiyonu.
   * @param event 
   * @param page 
  */
  const onPageChangeHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, page: number) => {
    setPage(page);
    dispatch(MesajSlice.actions.setModulListeFetching(true));
  };
  /**
   * Server side çalıştırmak için table pagination componenti kullanıldı sayfa x kayıt görünsün fonksiyonu.
   * @param event 
  */
  const onRowsPerPageChangeHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(MesajSlice.actions.setModulListeFetching(true));
  };
  return (
    <>
      <Tooltip arrow title={translate(translatePath, "Bildirimler")}>
        <ModernHeaderButton onClick={popoverOpenHandler}>
          <NotificationsBadge
            badgeContent={Array.isArray(querySayac.data) ? querySayac.data?.reduce((p, c) => p = p + c?.okumaBilgisi, 0) : 0}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            <NotificationsActiveTwoToneIcon />
          </NotificationsBadge>
        </ModernHeaderButton>
      </Tooltip>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        onClose={popoverCloseHandler}
        disableRestoreFocus
      >
        <Box
          sx={{ p: 1 }}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h5">{`${translate(translatePath, "Bildirimler")} (${Array.isArray(querySayac.data) ? (((total: number) => total > 99 ? '99+' : total)(querySayac.data.reduce((p, c) => p + (c?.okumaBilgisi || 0), 0))) : 0}/${query.totalRecords || 0})`}</Typography>
          <Box>
            <Tooltip title={translate(translatePath, "Mesaj Ekle")}>
              <IconButton size="small" color="primary" onClick={addHandler}>
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={translate(translatePath, "Kapat")}>
              <IconButton size="small" color="error" onClick={popoverCloseHandler}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Divider />
        <StyledBox sx={{ display: "flex", flexDirection: "column", height: 500, width: 440, bgcolor: "background.paper" }}>
          <List dense sx={{ flexGrow: 1, width: 440, bgcolor: "background.paper" }} disablePadding>
            {(query.data?.length > 0) ? query.data?.map((m, i) => {
              return (
                <div key={helper.objectToString("mesaj-liste-1" + i)}>
                  <ListItemButton key={helper.objectToString("list-item-button" + i)} alignItems="flex-start" onClick={(e) => { detailHandler(e, m); }}>
                    <ListItemText
                      key={helper.objectToString("list-item-text" + i)}
                      primary={
                        <React.Fragment>
                          {m?.mesajtip === 1 ? (
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ flexShrink: 0 }}>
                                <FontAwesomeIcon icon={faFolder} size="sm" style={{ color: "black", height: 12, width: 12 }} />
                                {`${translate(translatePath, "Modül: ")} ${m?.modulAdi}`}
                              </div>
                              {m?.muracaatId > 0 && (
                                <div style={{ textAlign: 'right', flexShrink: 1, marginLeft: '10px' }}>
                                  {`${translate(translatePath, "Hasta: ")} ${m?.hastaAdiSoyadi}`}
                                </div>
                              )}
                            </div>
                          ) : (
                            <>
                              <FontAwesomeIcon icon={faUserAlt} size="sm" style={{ color: "black", height: 12, width: 12 }} /> {`${translate(translatePath, "Alıcı: ")} ${m?.mesajAlanPersonel}`}
                            </>
                          )}
                          <Box key={helper.objectToString("box-1" + i)} flex="1">
                            <Box key={helper.objectToString("box-2" + i)} display="flex" justifyContent="space-between">
                              <Typography
                                key={helper.objectToString("typography-1" + i)}
                                sx={{ fontWeight: querySayacData?.length === 0 ? "400" : (Array.isArray(querySayacData) && querySayacData?.find((f) => f?.mesajId === m?.id)?.okumaBilgisi > 0) ? "700" : "400" }}
                              >
                                {helper.kisaMetin(m?.baslik, 20)}
                              </Typography>
                              <Typography key={helper.objectToString("typography-2" + i)} variant="caption" sx={{ textTransform: 'none' }}>
                                {helper.dateValueFormat3(m?.eklemeTarihi)}
                              </Typography>
                            </Box>
                            <Typography
                              key={helper.objectToString("typography-3" + i)}
                              sx={{ display: 'inline' }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              {m?.mesajGonderen}
                            </Typography>
                            {` — ${helper.kisaMetin(m?.icerik, 80)}`}
                          </Box>
                        </React.Fragment>
                      }
                    />
                  </ListItemButton>
                  <Divider />
                </div>
              );
            }) : (
              <Box sx={{ maxHeight: 500, width: 440, p: 0, bgcolor: "background.paper" }}>
                {state.modulListeFetching && Array.from({ length: 15 }).map((_, index) => (
                  <ListItemButton key={helper.objectToString("list-item-button-skeleton" + index)} alignItems="flex-start">
                    <ListItemText
                      key={helper.objectToString("list-item-text-skeleton" + index)}
                      primary={
                        <React.Fragment>
                          <Skeleton key={helper.objectToString("skeleton" + index)} />
                        </React.Fragment>
                      }
                    >
                    </ListItemText>
                  </ListItemButton>
                ))}
              </Box>
            )}
          </List>
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%", position: "sticky", bottom: "-2px", bgcolor: "background.paper" }}>
            <Divider />
            <TablePagination
              variant="head"
              count={query?.totalRecords}
              page={page}
              onPageChange={onPageChangeHandler}
              rowsPerPage={pageSize}
              onRowsPerPageChange={onRowsPerPageChangeHandler}
            />
          </Box>
        </StyledBox>
      </Popover>
      {state.modulOpen && <NotificationDetails />}
    </>
  );
};

export default HeaderNotifications;
